import React from 'react';
import PropTypes from 'prop-types';
import { buildSizes, buildSrcSet } from '../../../helper/index';

import { StyledImage } from './image.style';

const Image = ({ alt, altText, src, srcset, sizes, lazy, className }) => {
  let image = {
    alt: alt || altText || ''
  };

  if (srcset && lazy) {
    image['data-srcset'] = buildSrcSet(srcset);
  } else if (srcset) {
    image.srcSet = buildSrcSet(srcset);
  } else {
    image['data-srcset'] = src;
  }

  if (sizes && lazy) {
    image['data-sizes'] = buildSizes(sizes);
  } else if (sizes) {
    image.sizes = buildSizes(sizes);
  }

  if (lazy === 'lqip') {
    image = {
      ...image,
      src
    };
  } else if (lazy === 'default') {
    image = {
      ...image,
      'data-src': src
    };
  } else {
    image = {
      ...image,
      src
    };
  }

  return <StyledImage className={`${className} ${lazy ? 'lazyload' : ''}`} {...image} />;
};

Image.propTypes = {
  className: PropTypes.string,
  alt: PropTypes.string,
  altText: PropTypes.string,
  title: PropTypes.string,
  src: PropTypes.string,
  srcset: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      suffix: PropTypes.string
    })
  ),
  sizes: PropTypes.arrayOf(
    PropTypes.shape({
      condition: PropTypes.string,
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ),
  lazy: PropTypes.oneOf(['default', 'lqip'])
};

export default Image;
